import Vue from 'vue';
import bkService from '../services/bk.service';

const handlers = {
  bk: {
    session: {
      set: 'bk_session_set'
    }
  }
}

const initVuexState = function(state) {
  state.bk = {
    session: null
  };
}

const initGetters = function(getters) {
  getters.bk = (state => state.bk);
}

const initActions = function(actions) {
  actions[handlers.bk.session.set] = ({ commit }, session) => commit(handlers.bk.session.set, session);
}

const initMutations = function(mutations) {
  mutations[handlers.bk.session.set] = (state, session) => state.bk.session = session;
}

const initAppState = function(appState, store) {
  appState.bk = {
    session: {
      get: () => store.getters.bk.session,
      open: async (backUrl) => {
        let session = await bkService.openSession(backUrl);
        store.dispatch(handlers.bk.session.set, session);
      },
      close: async () => {
        if (store.getters.bk.session) {
          await bkService.closeSession();
        }
        store.dispatch(handlers.bk.session.set, null);
      }
    }
  }
}

export default {
  initVuex(vuexState, getters, actions, mutations) {
    initVuexState(vuexState);
    initGetters(getters);
    initActions(actions);
    initMutations(mutations);
  },
  initAppState(appState, store) {
    initAppState(appState, store);
  }
}



// WEBPACK FOOTER //
// ./_common/data/bk.js